// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/fullcalendar/dist/fullcalendar.css
// module id = 1670
// module chunks = 2